import { toBuildingSelectItems } from '../../../../Building'

export function toBuildingSelectItemFromOpenData(item) {
  return {
    ...(item.avatar ? { avatar: { src: item.avatar } } : null),
    label: item.address,
    value: item.id,
  }
}

export function toBuildingSelectItemsFromOpenData(items) {
  return toBuildingSelectItems(items, toBuildingSelectItemFromOpenData)
}

export function getBuildingSelectSearchParam(searchValue) {
  return searchValue ? { address: searchValue } : null
}

export function getFlatSelectSearchParam(searchValue) {
  return searchValue ? { number: searchValue } : null
}
